import { useEffect, useState } from "react";
import { format } from "date-fns";
import { api, TIER_LABEL } from "../../lib/api";

const fmt = (d) => (d ? format(new Date(d), "MMM d, yyyy") : "—");
const th = "text-left font-mono-x text-[0.65rem] tracking-[0.2em] uppercase text-[#4A5878] font-normal px-5 py-4";
const td = "px-5 py-4 text-sm text-[#26355A] whitespace-nowrap";

function useList(url) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get(url).then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => setRows([]));
  }, [url]);
  return rows;
}

const Wrap = ({ children, testid }) => (
  <div data-testid={testid} className="border border-[#0E1B3D]/[0.08] bg-[#FFFFFF] overflow-x-auto"><table className="w-full">{children}</table></div>
);

export function Members() {
  const rows = useList("/admin/subscribers");
  return (
    <Wrap testid="admin-members-table">
      <thead className="border-b border-[#0E1B3D]/[0.08]"><tr><th className={th}>Member</th><th className={th}>Tier</th><th className={th}>Since</th><th className={th}>Joined</th><th className={th}>Tips</th></tr></thead>
      <tbody>
        {rows.length === 0 && <tr><td className={td} colSpan={5}>No members yet.</td></tr>}
        {rows.map((u) => (
          <tr key={u.user_id} data-testid="admin-member-row" className="border-b border-[#0E1B3D]/[0.05]">
            <td className={td}><p className="text-[#0E1B3D]">{u.name}{u.is_tester && <span data-testid="admin-member-tester-tag" className="ml-2 font-mono-x text-[0.6rem] tracking-[0.18em] uppercase border border-[#2F6FD6]/40 text-[#2F6FD6] px-1.5 py-0.5">Tester</span>}</p><p className="text-xs text-[#4A5878]">{u.email}</p></td>
            <td className={td}><span className={u.tier ? "text-[#D7263D]" : "text-[#4A5878]"}>{TIER_LABEL[u.tier] || "Not subscribed"}</span></td>
            <td className={td}>{fmt(u.tier_since)}</td>
            <td className={td}>{fmt(u.joined)}</td>
            <td className={td}>${(u.tips_total ?? 0).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </Wrap>
  );
}

export function Tips() {
  const rows = useList("/admin/tips");
  return (
    <Wrap testid="admin-tips-table">
      <thead className="border-b border-[#0E1B3D]/[0.08]"><tr><th className={th}>From</th><th className={th}>Amount</th><th className={th}>Note</th><th className={th}>Date</th></tr></thead>
      <tbody>
        {rows.length === 0 && <tr><td className={td} colSpan={4}>No tips yet.</td></tr>}
        {rows.map((t) => (
          <tr key={t.id} data-testid="admin-tip-row" className="border-b border-[#0E1B3D]/[0.05]">
            <td className={td}>{t.user_name}</td>
            <td className={`${td} text-[#D7263D]`}>${t.amount}</td>
            <td className={`${td} whitespace-normal max-w-xs`}>{t.note || "—"}</td>
            <td className={td}>{fmt(t.created_at)}</td>
          </tr>
        ))}
      </tbody>
    </Wrap>
  );
}
